import type { ReportMetric } from '../../api/types'
import type { Tone } from './tone'
import styles from './Reports.module.css'

/**
 * One metric, as a card: figure, glyph, label, and a line explaining what the
 * metric means.
 *
 * The label answers "what is this?" and the description answers "so what?".
 * They deliberately differ: the card first showed the backend's counted
 * sentence, which under a title like "No confirmed budget" read "Opportunities
 * have no confirmed budget" and taught the reader nothing (Mike, 2026-08-22).
 * The counted sentence still heads the evidence panel, where the number is the
 * point.
 *
 * The card is the only navigation on this page — there is no "view all" beside
 * it, because a second control would imply the number and the list were
 * different destinations. The number IS the list.
 */
export function MetricCard({
  metric,
  tone,
  expanded,
  onToggle,
  id,
  controls,
}: {
  metric: ReportMetric
  tone: Tone
  expanded: boolean
  onToggle: () => void
  id: string
  controls: string
}) {
  return (
    <li>
      <button
        type="button"
        id={id}
        className={styles.card}
        data-tone={tone}
        aria-expanded={expanded}
        aria-controls={expanded ? controls : undefined}
        onClick={onToggle}
      >
        <span className={styles.cardCount}>{metric.count}</span>
        <span className={styles.cardLabel}>{metric.label}</span>
        <span className={styles.cardSentence}>{metric.description}</span>
      </button>
    </li>
  )
}
